import * as ajax from "./ajax";

async function transformResponse(res, transformData) {
  const { response, data, error } = await res;
  if (error) {
    throw typeof error === "string" ? new Error(error) : error;
  }
  if (transformData) {
    return {
      ...data,
      data: data.data ? transformData(data.data) : data.data
    };
  }
  return data;
}

export default {
  request({ transformData, ...config } = {}) {
    return transformResponse(ajax.request(config), transformData);
  },
  post(url, data = {}, { transformData, ...config } = {}) {
    return transformResponse(ajax.POST(url, data, config), transformData);
  },
  get(url, data = {}, { transformData, ...config } = {}) {
    return transformResponse(ajax.GET(url, data, config), transformData);
  },
  uploadImage(file, { transformData, ...config } = {}) {
    const data = new FormData();
    const url = "/app/file/upload/images";

    data.append("file", file.file || file);

    return transformResponse(
      ajax.POST(url, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        ...config,
        disCrypto: true
      }),
      transformData
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/request.js